<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-bank">
            <template #title>
                Банк
            </template>

            <ButtonComeBack class="ml-3 mb-3" />
            <v-col cols="12" lg="6">
                <v-form lazy-validation v-model="isValidForm" ref="form">
                    <v-row>
                        <!--Проекти-->
                        <v-col cols="12">
                            <v-switch v-model="bank.enabled" label="Включено"></v-switch>
                        </v-col>
                        <!-- Код банку -->
                        <v-col cols="12">
                            <v-text-field label="Код банку" v-model="bank.code" required
                                :rules="[v => !!v || errorRequired]" />
                        </v-col>
                        <!-- Тип кредиту -->
                        <v-col cols="12">
                            <v-select v-model="bank.credit_type" :items="creditTypes" item-text="name" item-value="name"
                                label="Тип кредиту" required :rules="[v => !!v || errorRequired]" />
                        </v-col>
                        <!-- URL -->
                        <v-col cols="12">
                            <v-text-field label="URL" hint="https://" v-model="bank.url" />
                        </v-col>


                    </v-row>

                    <!--Табы-->
                    <v-col cols="12">
                        <v-tabs v-model="tab">
                            <v-tab v-for="local in localization" :key="local.lang_key">
                                {{ local.name }}
                            </v-tab>
                        </v-tabs>
                    </v-col>

                    <!--Содержымое табов-->
                    <v-col cols="12">
                        <v-tabs-items v-model="tab">
                            <v-tab-item v-for="(item, index) in bank.langs" :key="item.lang_key" :eager="true">
                                <template>
                                    <!--Назва-->
                                    <v-text-field label="Назва" v-model="item.name"  />
                                    <!-- Комментарій -->
                                    <v-textarea label="Коментарій" v-model="item.comment" />
                                    <!--Картинка-->
                                    <ImageUpload v-if="id" v-model="item.image" @image-upload:change="changeImage($event, {
                                        lang_key: item.lang_key,
                                        lang_name: item.lang_name,
                                        object_image_id: id,
                                        image_type: 'bank_image',
                                    })" :imageBaseUrl="imageBaseUrl" />
                                </template>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>

                    <!--Кнопки-->
                    <v-col cols="12" class="text-right">
                        <v-btn color="primary" min-width="150" @click="sendForm()">
                            Зберегти
                        </v-btn>
                    </v-col>
                    <Preloader v-if="isSending" />
                </v-form>
            </v-col>

        </material-card>
    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'PageBankAdd',
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            bank: {
                id: null,
                enabled: true,
                url: '',
                code: '',
                credit_type: '',
                langs: [],
            },
            bankData: [],
            creditTypes: [
                { name: 'INSTALLMENT' },
                { name: 'POS' },
            ],
            // Активный таб
            tab: 0,
            isValidForm: true,
            errorRequired: `Це поле обов'язкове`,
            isSending: false,
            imageBaseUrl: `${IMAGE_BASE_URL}banks/`,
            // Изображения для отправки 
            imagesToSend: {},

        }
    },
    computed: {
        ...mapGetters(['snackbar', 'localization'])
    },
    mounted() {
        this.init();
    },

    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getLocalization']),
        // Подготовка данных
        async init() {
            if (this.id) {
                const bankData = await HTTP.post('/get-bank', { id: this.id });
                this.bankData = bankData.data.content;
                const d = this.bankData;
                this.bank = {
                    id: this.id,
                    enabled: d[0].enabled,
                    url: d[0].url,
                    code: d[0].code,
                    credit_type: d[0].credit_type,
                    langs: [],
                };
            }
            await this.getLocalization();

            this.bank.langs = this.localization.map((el) => {
                const image = this.bankData.find(item => item.lang_id === el.lang_id)?.image || '';
                return {
                    lang_key: el.lang_key,
                    lang_name: el.name,
                    name: this.bankData.find(item => item.lang_id === el.lang_id)?.name || '',
                    comment: this.bankData.find(item => item.lang_id === el.lang_id)?.comment || '',
                    image: image ? this.imageBaseUrl + image : ''
                };
            });
        },
        changeImage(event, params) {
            let key = `${params.lang_key} ${params.image_type}`
            if (event.action) {
                event.params = params;
                this.imagesToSend[key] = event;
            } else {
                delete this.imagesToSend[key];
            }
        },

        // Запускает процесс отравки изображений, отправкой занимается "ImageUpload"
        async runProcessImagesSend() {

            let errors = '';
            for (let key in this.imagesToSend) {
                let { params, sendImage } = this.imagesToSend[key];
                let result = await sendImage(params);
                // Если при загрузке изображений были ошибки - показать попап
                if (!result.error) {
                    delete this.imagesToSend[key];
                } else {
                    errors += `Таб Опис: ${result.error}</br>`;
                    this.setSnackbar({ type: 'error', text: errors });
                    // Редирект при закрытии попапа "setSnackbar $watch" 
                    let unwatch = this.$watch('snackbar.model', (newVal, oldVal) => {
                        unwatch();
                    });
                }
            }
            this.isSending = false;
        },

        // Создать список ошибок (ошибки надо показать в попапе - потому что табы)
        createListErrors() {
            let errors = '';
            for (let item of this.bank.langs) {
                if (!item.name) {
                    errors += `Помилка в табi "${item.lang_name}"</br>`;
                }
            }
            return errors;
        },

        // Отправка формы
        async sendForm() {
            this.errorDate = '';
            let isImages = Object.keys(this.imagesToSend).length;

            if (!this.$refs.form.validate()) {
                let errors = this.createListErrors();
                if (errors) {
                    this.setSnackbar({ type: 'error', text: errors });
                };
                return;
            };

            this.isSending = true;

            try {
                if (this.id) {
                    await HTTP.post("/update-bank", {
                        id: this.id,
                        ...this.bank,
                        langs: this.bank.langs.map((el) => {
                            return {
                                lang_key: el.lang_key,
                                name: el.name,
                                comment: el.comment,
                            };
                        })
                    });
                    this.setSnackbar({ type: 'success', text: 'Успiшно збережено' });
                    if (!isImages) {
                        this.isSending = false;
                    } else {
                        let unwatch = this.$watch('snackbar.model', (newVal, oldVal) => {
                            this.runProcessImagesSend();
                            unwatch();
                        });
                    }
                } else {
                    let { data } = await HTTP.post("/create-bank", {
                        ...this.bank,
                        langs: this.bank.langs.map((el) => {
                            return {
                                lang_key: el.lang_key,
                                name: el.name,
                                comment: el.comment,
                            };
                        })
                    });
                    this.setSnackbar({ type: 'success', text: 'Успiшно збережено' });
                    this.$router.push(`/banks/${data.content.id}/`);
                }
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
                this.isSending = false;
            }
        },

    },
}
</script>

<style scoped lang="sass">
.form-bank-add
  position: relative
</style>
